window.addEventListener("DOMContentLoaded", () => {
  const e = localStorage.getItem("cart_protection");
  if (
    (window.location.href.includes("nvd-preview=true") && sessionStorage.setItem("ndvPreview", !0),
    null != e && void 0 !== e)
  ) {
    const o = e,
      t = {
        method: "POST",
        headers: { "Content-Type": "application/json;", Accept: "application/json" },
        body: JSON.stringify({ id: String(o), quantity: 0 }),
      };
    fetch("/cart/change.js", t)
      .then((e) => e.json())
      .then((e) => {
        console.log(e),
          localStorage.removeItem("nvd_opted_out"),
          localStorage.removeItem("reloaded"),
          localStorage.removeItem("navidium_variant"),
          localStorage.removeItem("cart_protection"),
          localStorage.removeItem("protection_price"),
          localStorage.removeItem("navidium_reload"),
          window.location.reload();
      });
  }
  !(function () {
    const e = Shopify.currency;
    localStorage.setItem("nvdCurrency", JSON.stringify(e));
  })();
});
